<template>
  <div class="station">
    <time-table v-if="this.buses" :journeys="this.items.buses" :stationName="stationName" :color="color" :showDistance="showDistance" :distance="distance" :showTimetableDisplayName="showTimetableDisplayName" :displayName="'Buss'" type="bus" :destinationHeading="destinationHeading" :departureHeading="departureHeading" :footerText="footerText"></time-table>
    <time-table v-if="this.trains" :journeys="this.items.trains" :stationName="stationName" :color="color" :showDistance="showDistance" :distance="distance" :showTimetableDisplayName="showTimetableDisplayName" :displayName="'Pendeltåg'" type="train" :destinationHeading="destinationHeading" :departureHeading="departureHeading" :footerText="footerText"></time-table>
    <time-table v-if="this.metros" :journeys="this.items.metros" :stationName="stationName" :color="color" :showDistance="showDistance" :distance="distance" :showTimetableDisplayName="showTimetableDisplayName" :displayName="'Tunnelbana'" type="metro" :destinationHeading="destinationHeading" :departureHeading="departureHeading" :footerText="footerText"></time-table>
    <time-table v-if="this.trams" :journeys="this.items.trams" :stationName="stationName" :color="color" :showDistance="showDistance" :distance="distance" :showTimetableDisplayName="showTimetableDisplayName" :displayName="'Tvärbana'" type="tram" :destinationHeading="destinationHeading" :departureHeading="departureHeading" :footerText="footerText"></time-table>
    <time-table v-if="this.ships" :journeys="this.items.ships" :stationName="stationName" :color="color" :showDistance="showDistance" :distance="distance" :showTimetableDisplayName="showTimetableDisplayName" :displayName="'Båt'" type="boat" :destinationHeading="destinationHeading" :departureHeading="departureHeading" :footerText="footerText"></time-table>
    <div class="updated" v-if="showLastUpdated && minutesSinceUpdate > 10">Hållplatsen senaste uppdaterad: {{ latestUpdate.format('D/M H:mm') }}</div>
  </div>
</template>

<script>
import TimeTable from './TimeTable.vue'
import moment from 'moment'

export default {
  props: {
    showTimetableDisplayName: {
      type: Boolean,
      default: false
    },  
    stationName: {
      type: String,
      required: true
    },
    stopareaname: {
      type: String,
      required: false
    },
    color: {
      type: String,
      required: false
    },
    journeys: {
      type: Object
    },
    distance: {
      type: Object
    },
    showDistance: {
      type: Boolean,
      default: false
    },
    limit: {
      type: Number,
      default: undefined
    },
    exclude: {
      type: Array
    },
    buses: {
      type: Boolean,
      default: false
    },
    trains: {
      type: Boolean,
      default: false
    },
    metros: {
      type: Boolean,
      default: false
    },
    trams: {
      type: Boolean,
      default: false
    },
    ships: {
      type: Boolean,
      default: false
    },
    destinationHeading: {
      type: String,
      default: 'Destination'
    },
    departureHeading: {
      type: String,
      default: 'Avgång'
    },
    footerText: {
      type: String,
      default: ''
    },
    showLastUpdated: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    journeys: {
      handler (val) {
        console.log("limit", this.limit)
        this.latestUpdate = moment(val.LatestUpdate)
        this.minutesSinceUpdate = moment().diff(this.latestUpdate, 'minutes')
        this.items.buses = this.buses ? this.filterItems(val.Buses, this.limit) : []
        this.items.trains = this.trains ? this.filterItems(val.Trains, this.limit) : []
        this.items.metros = this.metros ? this.filterItems(val.Metros, this.limit) : []
        this.items.trams = this.trams ? this.filterItems(val.Trams, this.limit) : []
        this.items.ships = this.ships ? this.filterItems(val.Ships, this.limit) : []
      }
    }
  },
  data () {
    return {
      latestUpdate: null,
      minutesSinceUpdate: null,
      items: {
        buses: [],
        trains: [],
        metros: [],
        trams: [],
        ships: []
      }
    }
  },
  methods: {
    filterItems (items, maxCount) {
      if (!items.length) return []
      // eslint-disable-next-line
      // console.log(items);

// items.forEach(element => {
//   console.log(moment(element.ExpectedDateTime).diff(new moment(), 'minutes'));
//   // console.log(moment(element.ExpectedDateTime).diff(new moment(), 'minutes'))
// });

      items = items.filter(x => (x.StopPointNumber !== 10803 && x.ExpectedDateTime && moment(x.ExpectedDateTime).diff(new moment(), 'minutes') > 0) || !x.ExpectedDateTime).map(x => { // hide edge case skansen
        
        // console.log('filtered item', x)
        
        return Object.assign({}, x, {
          Destination: x.StopPointNumber === 10804 ? `${x.Destination} via Norrtull och Sveavägen` : x.Destination, // edge case Skansen, update to better Destination name
          DisplayTime: this.calculateDisplayTime(x)
        })
      })
      if (this.exclude && this.exclude.length > 0) {
        return items.filter(x => this.exclude.indexOf(x.LineNumber) < 0).slice(0, maxCount)
      }
      return items.slice(0, maxCount)
    },
    calculateDisplayTime (journey) {
      // eslint-disable-next-line
      let diff = moment(journey.ExpectedDateTime).diff(new moment(), 'minutes')
      return (journey.ExpectedDateTime) ? diff < 2 ? 'Nu' : diff + ' min' : journey.DisplayTime
      // return (journey.ExpectedDateTime) ? moment(journey.ExpectedDateTime).diff(this.latestUpdate, 'minutes') + ' min' : journey.DisplayTime
    }
  },
  components: {
    TimeTable
  }
}
</script>

<style scoped lang="scss">
  .station {
    break-inside: avoid;
    display: block;
    aside {
      font-size: 1rem;
      font-style: italic;
      margin-right: 5px;
      text-align: right;
    }
    .updated {
      font-size: 1.2rem;
    }
  }
</style>
